import * as actionTypes from "../../actionLabels/index";

const initialState = {
  fetchAuctionBidHistoryDataReducer: [],
  fetchAuctionBidHistoryDataReducerApiCall: false,
  fetchAuctionBidHistoryDataReducerExport: {},
  fetchSearchDropDownForAuctionBidHistory: [],
};

const auctionBidHistoryReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_AUCTION_BID_HISTORY_DATA_SUCCESS:
      return {
        ...state,
        fetchAuctionBidHistoryDataReducer: action.payload,
      };

    case actionTypes.FETCH_AUCTION_BID_HISTORY_DATA_FAILURE:
      return {
        ...state,
        fetchAuctionBidHistoryDataReducer: [],
      };

    case actionTypes.FETCH_AUCTION_BID_HISTORY_DATA_EXPORT_SUCCESS:
      return {
        ...state,
        fetchAuctionBidHistoryDataReducerExport: action.payload,
      };

    case actionTypes.FETCH_AUCTION_BID_HISTORY_DATA_API_CALL:
      return {
        ...state,
        fetchAuctionBidHistoryDataReducerApiCall: action.payload,
      };

    case actionTypes.FETCH_AUCTION_BID_HISTORY_LOT_WISE_DATA_SUCCESS:
      return {
        ...state,
        fetchAuctionBidHistoryLotWiseDataReducer: action.payload,
      };

    case actionTypes.FETCH_AUCTION_BID_HISTORY_LOT_WISE_DATA_FAILURE:
      return {
        ...state,
        fetchAuctionBidHistoryLotWiseDataReducer: [],
      };

    case actionTypes.FETCH_AUCTION_BID_HISTORY_LOT_WISE_DATA_API_CALL:
      return {
        ...state,
        fetchAuctionBidHistoryLotWiseDataReducerApiCall: action.payload,
      };

    case actionTypes.FETCH_SEARCH_DROP_DOWN_FOR_AUCTION_BID_HISTORY_SUCCESS:
      return {
        ...state,
        fetchSearchDropDownForAuctionBidHistory: action.payload,
      };

    case actionTypes.FETCH_SEARCH_DROP_DOWN_FOR_AUCTION_BID_HISTORY_FAILURE:
      return {
        ...state,
        fetchSearchDropDownForAuctionBidHistory: [],
      };

    default:
      return state;
  }
};

export default auctionBidHistoryReportReducer;
